import { crmAxiosWithToken, cpqAxiosWithToken } from '../http-common';

class CRMService {

    getCRMOpportunity(opportunityId) {        
        return crmAxiosWithToken.get(`Opportunity/GetOpportunity/?OpportunityId=${opportunityId}`);
    }    

    getCrmUploadData(quoteId) {
        return cpqAxiosWithToken.get(`Crm/GetCrmUploadData/?quoteId=${quoteId}`);
    }

    getCrmDataSync(){
        return cpqAxiosWithToken.get('CrmDataSync/CrmDataSync');
    }

    getQuoteDetailsFromCrm(opportunityId) {
        return crmAxiosWithToken.get(`Opportunity/QuoteDetails?opportunityId=${opportunityId}`);
    }

    getCrmPopulationUploadData(quoteId) {
        return cpqAxiosWithToken.get(`Crm/GetCrmPopulationUploadData/?quoteId=${quoteId}`);
    }

    addOpportunityProduct(opportunityProduct) {
        return crmAxiosWithToken.post("Opportunity/AddOpportunityProduct", opportunityProduct)
    }

    addCountryHeadcount(cpqCountryHCRequestModell) {
        return crmAxiosWithToken.post("Opportunity/AddCountryHeadcount", cpqCountryHCRequestModell)
    }

    addBundledProduct(bundleObject) {
        return crmAxiosWithToken.post("Opportunity/AddBundleOpportunityProducts", bundleObject)
    }
}

export default new CRMService();